if (!customElements.get('header-modifier')) {
  class HeaderModifier extends HTMLElement {
    constructor() {
      super();
      this.apply = this.apply.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.header');
      if (!this.header) return;

      this.customizeMobile = this.dataset.customizeMobile === 'true';
      this.colorScheme = this.dataset.colorScheme;
      this.colorSchemeTransparent = this.dataset.colorSchemeTransparent;
      this.transparent = this.dataset.transparent === 'true';
      this.colorSchemeMobile = this.dataset.colorSchemeMobile;
      this.colorSchemeTransparentMobile = this.dataset.colorSchemeTransparentMobile;
      this.transparentMobile = this.dataset.transparentMobile === 'true';

      this.logoLink = this.header.querySelector('.header__logo-link');
      this.logoTemplates = {
        desktop: this.querySelector('template[data-logo-variant="desktop"]'),
        mobile: this.querySelector('template[data-logo-variant="mobile"]'),
      };
      this.logoNodes = {};

      this.mediaQuery = window.matchMedia('(min-width: 1024px)');
      this._abortController = new AbortController();
      this._observer = new MutationObserver(this.apply);
      this._observer.observe(this.header, { attributes: true, attributeFilter: ['class'] });

      this.apply();
      this.mediaQuery.addEventListener('change', this.apply, { signal: this._abortController.signal });
    }

    disconnectedCallback() {
      this._abortController?.abort();
      this._observer?.disconnect();
    }

    apply() {
      const isMobileOverride = !this.mediaQuery.matches && this.customizeMobile;
      const menuOpen = this.header.classList.contains('header--menu-open');
      const transparent = menuOpen ? false : (isMobileOverride ? this.transparentMobile : this.transparent);
      const isScrolled = this.header.classList.contains('header--scrolled') || this.header.classList.contains('header--search-open') || menuOpen;

      const openMenuScheme = this.header.dataset.menuScheme || this.header.dataset.colorSchemeDrawer;
      const colorScheme = menuOpen && openMenuScheme
        ? openMenuScheme
        : transparent && !isScrolled
          ? (isMobileOverride ? this.colorSchemeTransparentMobile : this.colorSchemeTransparent)
          : (isMobileOverride ? this.colorSchemeMobile : this.colorScheme);

      const targetClass = `color-${colorScheme}`;
      const currentClass = Array.from(this.header.classList).find((className) => className.startsWith('color-'));
      if (currentClass !== targetClass) {
        if (currentClass) this.header.classList.remove(currentClass);
        this.header.classList.add(targetClass);
      }

      if (this.header.classList.contains('header--transparent') !== transparent) {
        this.header.classList.toggle('header--transparent', transparent);
      }

      this._applyLogo(isMobileOverride, transparent, isScrolled);
    }

    _getLogoNode(variant) {
      if (this.logoNodes[variant]) return this.logoNodes[variant];
      if (!this.logoLink) return null;

      const node = this.logoTemplates[variant]?.content.firstElementChild?.cloneNode(true);
      if (!node) return null;

      this.logoLink.appendChild(node);
      this.logoNodes[variant] = node;
      return node;
    }

    _applyLogo(isMobileOverride, transparent, isScrolled) {
      if (!this.logoLink) return;

      const variant = isMobileOverride ? 'mobile' : 'desktop';
      const showModifierLogo = transparent && !isScrolled;
      const node = showModifierLogo ? this._getLogoNode(variant) : null;

      this.logoLink.classList.toggle('is-modifier-logo-owner', transparent);
      this.logoLink.classList.toggle('is-modifier-logo-active', !!node);
      this.logoLink.classList.toggle('is-modifier-logo-mobile', !!node && isMobileOverride);
    }
  }

  customElements.define('header-modifier', HeaderModifier);
}
